document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sk-acc]').forEach(function (acc) {
    var head = acc.querySelector('[data-sk-acc-h]');
    if (!head) return;
    head.addEventListener('click', function () {
      acc.classList.toggle('is-open');
    });
  });

  document.querySelectorAll('.sk-swatch-row:not(.sk-swatch-row--picker)').forEach(function (row) {
    row.querySelectorAll('.sk-sw:not(a):not(button)').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        row.querySelectorAll('.sk-sw').forEach(function (x) {
          x.classList.remove('on');
        });
        sw.classList.add('on');
      });
    });
  });

  /* Hero load animation */
  document.querySelectorAll('[data-sk-hero]').forEach(function (hero) {
    requestAnimationFrame(function () {
      hero.classList.add('is-loaded');
    });
  });

  /* Scroll reveals */
  var revealEls = document.querySelectorAll('.sk-rv');
  if (revealEls.length) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealEls.forEach(function (el) {
        el.classList.add('is-in');
      });
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      revealEls.forEach(function (el) {
        io.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add('is-in');
      });
    }
  }

  /* Product rails */
  document.querySelectorAll('[data-sk-rail-section]').forEach(function (section) {
    var rail = section.querySelector('[data-sk-rail]');
    var bar = section.querySelector('[data-sk-rail-bar]');
    var prev = section.querySelector('[data-sk-rail-prev]');
    var next = section.querySelector('[data-sk-rail-next]');
    if (!rail) return;

    function updateBar() {
      if (!bar) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var ratio = max > 0 ? rail.scrollLeft / max : 0;
      var widthPct = max > 0 ? Math.max(18, (rail.clientWidth / rail.scrollWidth) * 100) : 100;
      bar.style.width = widthPct + '%';
      bar.style.transform = 'translateX(' + ratio * ((100 - widthPct) / widthPct) * 100 + '%)';
    }

    function scrollByDir(dir) {
      var amount = Math.max(rail.clientWidth * 0.72, 260);
      rail.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });
    rail.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar);
    updateBar();
  });

  /* Size guide modal — native <dialog>, focus trap, no library */
  document.querySelectorAll('[data-sk-size-guide]').forEach(function (root) {
    var dialog = root.querySelector('dialog');
    var openBtn = root.querySelector('[data-sk-size-guide-open]');
    var closeBtn = root.querySelector('[data-sk-size-guide-close]');
    if (!dialog || !openBtn) return;

    var lastFocus = null;

    function focusable() {
      return Array.prototype.slice
        .call(
          dialog.querySelectorAll(
            'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
          )
        )
        .filter(function (el) {
          return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
        });
    }

    function onKeydown(e) {
      if (e.key !== 'Tab') return;
      var nodes = focusable();
      if (!nodes.length) {
        e.preventDefault();
        return;
      }
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function open() {
      lastFocus = document.activeElement;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      dialog.addEventListener('keydown', onKeydown);
      var nodes = focusable();
      (closeBtn || nodes[0] || dialog).focus();
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    }

    dialog.addEventListener('click', function (e) {
      var panel = dialog.querySelector('.sk-size-dialog__panel');
      if (e.target === dialog || (panel && !panel.contains(e.target))) {
        close();
      }
    });

    dialog.addEventListener('close', function () {
      dialog.removeEventListener('keydown', onKeydown);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    });
  });
});

function skNormalizeUrl(url) {
  if (!url) return '';
  url = String(url).replace(/&amp;/g, '&').trim();
  if (url.indexOf('//') === 0) return (window.location.protocol || 'https:') + url;
  return url;
}

function skNormalizeSrcset(srcset) {
  if (!srcset) return '';
  srcset = String(srcset).replace(/&amp;/g, '&').trim();
  return srcset
    .split(',')
    .map(function (part) {
      var bits = part.trim().split(/\s+/);
      if (!bits[0]) return part.trim();
      bits[0] = skNormalizeUrl(bits[0]);
      return bits.join(' ');
    })
    .join(', ');
}

function skSelectCardColorway(wrap, btn) {
  if (!wrap || !btn) return;

  var links = wrap.querySelectorAll('[data-sk-card-link]');
  var img = wrap.querySelector('[data-sk-card-image]');
  var priceNodes = wrap.querySelectorAll('[data-sk-card-now]');
  var compareNodes = wrap.querySelectorAll('[data-sk-card-compare]');
  var sub = wrap.querySelector('[data-sk-card-sub]');
  var swatches = wrap.querySelectorAll('[data-sk-card-swatches] .sk-sw--picker');

  swatches.forEach(function (sw) {
    sw.classList.remove('on');
    sw.setAttribute('aria-pressed', 'false');
  });
  btn.classList.add('on');
  btn.setAttribute('aria-pressed', 'true');

  var url = btn.getAttribute('data-product-url');
  if (url) {
    links.forEach(function (link) {
      link.setAttribute('href', url);
    });
  }

  var src = skNormalizeUrl(btn.getAttribute('data-image-src'));
  var srcset = skNormalizeSrcset(btn.getAttribute('data-image-srcset'));
  var alt = btn.getAttribute('data-image-alt') || '';

  if (img && src) {
    img.classList.add('is-swapping');
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');

    var onDone = function () {
      img.classList.remove('is-swapping');
      img.removeEventListener('load', onDone);
      img.removeEventListener('error', onDone);
    };
    img.addEventListener('load', onDone);
    img.addEventListener('error', onDone);

    img.src = src;
    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.setAttribute('sizes', '(min-width: 990px) 25vw, 50vw');
    }
    if (alt) img.alt = alt;
    if (img.complete) onDone();

    /* Colourway changes product — drop multi-image hover gallery on this card */
    var gallery = wrap.querySelector('[data-sk-card-gallery]');
    if (gallery) {
      if (gallery._skStopGallery) gallery._skStopGallery();
      gallery.querySelectorAll('[data-sk-slide]:not([data-sk-card-image])').forEach(function (el) {
        el.remove();
      });
      var progress = gallery.querySelector('.sk-card__progress');
      if (progress) progress.remove();
      gallery.removeAttribute('data-sk-card-gallery');
      img.classList.add('is-active');
    }
  }

  var price = btn.getAttribute('data-price');
  var compare = btn.getAttribute('data-compare-price') || '';
  if (price) {
    priceNodes.forEach(function (el) {
      el.textContent = price;
    });
  }
  compareNodes.forEach(function (el) {
    if (compare) {
      el.textContent = compare;
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  });

  var label = btn.getAttribute('data-color-label');
  if (sub && label) {
    var base = sub.getAttribute('data-base-sub') || sub.textContent.replace(/\s*-\s*[^-]+$/, '').trim();
    sub.setAttribute('data-base-sub', base);
    sub.textContent = base ? base + ' - ' + label : label;
  }
}

document.addEventListener(
  'click',
  function (e) {
    var btn = e.target.closest('[data-sk-card-colorway] .sk-sw--picker');
    if (!btn) return;
    var wrap = btn.closest('[data-sk-card-colorway]');
    if (!wrap) return;
    e.preventDefault();
    e.stopPropagation();
    skSelectCardColorway(wrap, btn);
  },
  true
);

/* Product-card hover image gallery (Meshki-style progress + autoadvance) */
(function () {
  var DURATION = 1400;
  var hoverOk = window.matchMedia('(hover: hover) and (pointer: fine)');

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.skGalleryBound === '1') return;
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-sk-slide]'));
    var fills = Array.prototype.slice.call(gallery.querySelectorAll('.sk-card__bar i'));
    if (slides.length < 2) return;
    gallery.dataset.skGalleryBound = '1';

    var wrap = gallery.closest('.sk-card-wrap');
    if (!wrap) return;

    var idx = 0;
    var timer = null;
    var running = false;

    function resetBars(activeIndex) {
      fills.forEach(function (fill, n) {
        fill.style.transition = 'none';
        if (n < activeIndex) {
          fill.style.width = '100%';
        } else {
          fill.style.width = '0%';
        }
      });
      // force reflow so next transition always starts clean
      void gallery.offsetWidth;
    }

    function fillActiveBar(activeIndex) {
      var fill = fills[activeIndex];
      if (!fill) return;
      fill.style.transition = 'none';
      fill.style.width = '0%';
      void fill.offsetWidth;
      fill.style.transition = 'width ' + DURATION + 'ms linear';
      fill.style.width = '100%';
    }

    function show(i) {
      idx = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        slide.classList.toggle('is-active', n === idx);
      });
      resetBars(idx);
      if (running) fillActiveBar(idx);
    }

    function tick() {
      show(idx + 1);
    }

    function start(force) {
      if (running || (!hoverOk.matches && force !== true)) return;
      running = true;
      /* Advance on hover immediately — don't wait a full DURATION on image 1 */
      show(idx + 1);
      clearInterval(timer);
      timer = setInterval(tick, DURATION);
    }

    function stop() {
      running = false;
      clearInterval(timer);
      timer = null;
      idx = 0;
      show(0);
      resetBars(0);
    }

    gallery._skStopGallery = stop;

    wrap.addEventListener('mouseenter', start);
    wrap.addEventListener('mouseleave', stop);
    wrap.addEventListener('focusin', start);
    wrap.addEventListener('focusout', function (e) {
      if (!wrap.contains(e.relatedTarget)) stop();
    });

    /* Touch: press-and-hold on the image cycles photos like desktop hover */
    var HOLD_DELAY = 250;
    var MOVE_TOLERANCE = 10;
    var holdTimer = null;
    var holding = false;
    var suppressClick = false;
    var startX = 0;
    var startY = 0;

    function endHold() {
      clearTimeout(holdTimer);
      holdTimer = null;
      if (!holding) return;
      holding = false;
      wrap.classList.remove('is-holding');
      stop();
    }

    gallery.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch') return;
      suppressClick = false;
      startX = e.clientX;
      startY = e.clientY;
      clearTimeout(holdTimer);
      holdTimer = setTimeout(function () {
        holding = true;
        suppressClick = true;
        wrap.classList.add('is-holding');
        start(true);
      }, HOLD_DELAY);
    });

    gallery.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'touch' || holding || !holdTimer) return;
      if (Math.abs(e.clientX - startX) > MOVE_TOLERANCE || Math.abs(e.clientY - startY) > MOVE_TOLERANCE) {
        clearTimeout(holdTimer);
        holdTimer = null;
      }
    });

    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (type) {
      gallery.addEventListener(type, function (e) {
        if (e.pointerType === 'touch') endHold();
      });
    });

    gallery.addEventListener('contextmenu', function (e) {
      if (holding || holdTimer) e.preventDefault();
    });

    var mediaLink = gallery.closest('a');
    if (mediaLink) {
      mediaLink.addEventListener(
        'click',
        function (e) {
          if (!suppressClick) return;
          suppressClick = false;
          e.preventDefault();
          e.stopPropagation();
        },
        true
      );
    }
  }

  function boot() {
    document.querySelectorAll('[data-sk-card-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

/* Sticky offsets under announcement + header (PDP + collection filters) */
(function () {
  function setHeaderGroupHeight() {
    /* Group class is on each section — sum announcement + header heights */
    var nodes = document.querySelectorAll('.shopify-section-group-header-group');
    var h = 0;
    var annH = 0;
    if (nodes.length) {
      nodes.forEach(function (el) {
        var eh = Math.ceil(el.getBoundingClientRect().height) || 0;
        h += eh;
        if (el.classList.contains('announcement-bar-section')) annH = eh;
      });
    } else {
      var ann = document.querySelector('.announcement-bar-section, .sk-announce-bar');
      var hdr =
        document.querySelector('.section-header') ||
        document.querySelector('sticky-header') ||
        document.querySelector('header');
      annH = ann ? Math.ceil(ann.getBoundingClientRect().height) : 34;
      h = annH + (hdr ? Math.ceil(hdr.getBoundingClientRect().height) : 74);
    }
    if (!annH) annH = 34;
    if (!h) h = annH + 74;
    document.documentElement.style.setProperty('--sk-announcement-height', annH + 'px');
    document.documentElement.style.setProperty('--sk-header-group-height', h + 'px');
    if (document.querySelector('.sk-pdp')) {
      document.documentElement.style.setProperty('--sk-pdp-sticky-top', h + 12 + 'px');
    }
  }

  function boot() {
    setHeaderGroupHeight();
    window.addEventListener('resize', setHeaderGroupHeight, { passive: true });

    if ('ResizeObserver' in window) {
      document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) {
        new ResizeObserver(setHeaderGroupHeight).observe(el);
      });
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setHeaderGroupHeight).catch(function () {});
    }
    document.querySelectorAll('.sk-gallery img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', setHeaderGroupHeight, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
